import { BASE_HOST } from './uri.dev'

const BASE_URL = BASE_HOST
const DEFAULT_PER_PAGE = 15

const API_AUTH = {
    login: `${BASE_URL}/api/auth/login/`,
    checkToken: `${BASE_URL}/api/auth/check-token/`,
    clientLogin: `${BASE_URL}/api/auth/client-login/`,
    refreshToken: `${BASE_URL}/api/auth/refresh-token/`,
}

const API_USER = {
    list: `${BASE_URL}/api/user/`,
    create: `${BASE_URL}/api/user/`,
    get: {
        base: `${BASE_URL}/api/user/`, 
    },
    update: {
        base: `${BASE_URL}/api/user/`,
    },
    speciality: `${BASE_URL}/api/transcript/user/speciality/`,
    transcript: `${BASE_URL}/api/transcript/user/`,
    transcriptPdf: `${BASE_URL}/api/transcript/user/pdf/`,
}

const API_BASE = {
    courseGroup: {
        list: `${BASE_URL}/api/admin/preparation/group/`,
        base: `${BASE_URL}/api/admin/preparation/group/`,
        create: `${BASE_URL}/api/admin/preparation/group/`,
        get: {
            base: `${BASE_URL}/api/admin/preparation/group/`,
        },
        update: {
            base: `${BASE_URL}/api/admin/preparation/group/`,
        },
    },
    coursePreparation: {
        list: `${BASE_URL}/api/admin/preparation/course/`,
        base: `${BASE_URL}/api/admin/preparation/course/`,
        create: `${BASE_URL}/api/admin/preparation/course/`,
        get: {
            base: `${BASE_URL}/api/admin/preparation/course/`,
        },
        update: {
            base: `${BASE_URL}/api/admin/preparation/course/`,
        },
    },
    trainings: {
        list: `${BASE_URL}/api/admin/trainings/`,
        base: `${BASE_URL}/api/admin/trainings/`,
        create: `${BASE_URL}/api/admin/trainings/`,
        get: {
            base: `${BASE_URL}/api/admin/trainings/`,
        },
        update: {
            base: `${BASE_URL}/api/admin/trainings/`,
        },
    },
    library: {
        list: `${BASE_URL}/api/admin/library/`,
        base: `${BASE_URL}/api/admin/library/`,
        create: `${BASE_URL}/api/admin/library/`,
        get: {
            base: `${BASE_URL}/api/admin/library/`,
        },
        update: {
            base: `${BASE_URL}/api/admin/library/`,
        },
    },
    science: {
        list: `${BASE_URL}/api/admin/science/`,
        base: `${BASE_URL}/api/admin/science/`,
        create: `${BASE_URL}/api/admin/science/`,
        get: {
            base: `${BASE_URL}/api/admin/science/`,
        },
        update: {
            base: `${BASE_URL}/api/admin/science/`,
        },
    },
    speciality: {
        list: `${BASE_URL}/api/speciality/`,
        base: `${BASE_URL}/api/speciality/`,
        create: `${BASE_URL}/api/speciality/`,
        get: {
            base: `${BASE_URL}/api/speciality/`,
        },
        update: {
            base: `${BASE_URL}/api/speciality/`,
        },
    },
    libraryCat: {
        list: `${BASE_URL}/api/admin/library-category/`,
        base: `${BASE_URL}/api/admin/library-category/`,
        create: `${BASE_URL}/api/admin/library-category/`,
        get: {
            base: `${BASE_URL}/api/admin/library-category/`,
        },
        update: {
            base: `${BASE_URL}/api/admin/library-category/`,
        },
    },
}

const API_NEWS = {
    list: `${BASE_URL}/api/admin/news/`,
    base: `${BASE_URL}/api/admin/content/`,
    category: `${BASE_URL}/api/admin/category/`,
}

const API_CATEGORIES = {
    list: `${BASE_URL}/api/admin/category-inner/`,
    base: `${BASE_URL}/api/admin/category-inner/`,
}

const API_CATEGORIES_CLIENT = {
    base: `${BASE_URL}/api/category/`,
}

const API_CLIENT = {
    library: `${BASE_URL}/api/client/library/`,
    courses: `${BASE_URL}/api/client/courses/`,
    register: `${BASE_URL}/api/client/register/`,
    calendar: `${BASE_URL}/api/client/trainings/`,
    course: `${BASE_URL}/api/client/course/`,
    studentCourse: `${BASE_URL}/api/client/course/student/`,
    tsorThemes: `${BASE_URL}/api/client/tsor/filter/`,
    tsorDetail: `${BASE_URL}/api/client/tsor/`,
    tsorDetailVideo: `${BASE_URL}/api/client/tsor/video_create/`,
    courseStatus: `${BASE_URL}/api/client/course/status/`,
    moder: `${BASE_URL}/api/admin/preparation-course/`,
    questions: `${BASE_URL}/api/client/questions/`,
    adminQuestions: `${BASE_URL}/api/admin/questions/`,
    adminTsorAnswers: `${BASE_URL}/api/admin/tsor-answers/`,
    adminTsorQuestionsItem: `${BASE_URL}/api/admin/tsor-questions-item/`,
    adminEstimates: `${BASE_URL}/api/admin/preparation/estiamtes/`,
    certificate: `${BASE_URL}/api/client/certificate/`,
    clientLabQuestions: `${BASE_URL}/api/client/lab-questions/`,
    adminLabQuestions: `${BASE_URL}/api/admin/lab-questions/`,
    adminLabQuestionsItem: `${BASE_URL}/api/admin/lab-questions-item/`,
    adminLabAnswers: `${BASE_URL}/api/admin/lab-answers/`,
    labWorks: `${BASE_URL}/api/admin/lab-works/`,
}

const API_TSOR = {
    cathedra: `${BASE_URL}/api/tsor/cathedra/`,
    speciality: `${BASE_URL}/api/tsor/speciality/`,
    subject: `${BASE_URL}/api/tsor/subject/`,
    theme: `${BASE_URL}/api/tsor/theme/`,
    detail: `${BASE_URL}/api/tsor/`,
    video: `${BASE_URL}/api/tsor/video/`,
    videoCreate: `${BASE_URL}/api/tsor/video_create/`,
}

const HEADERS = {
    'Accept': 'application/json',
    'Content-Type': 'application/x-www-form-urlencoded'
}

const HEADERS_TOKEN = function(){
    const headers = {
        'Accept': 'application/json',
        'Content-Type': 'application/x-www-form-urlencoded'
    };
    const token = localStorage.getItem('user_token');
    if (token) {
        headers['Authorization'] = 'Token ' + token;
    }
    return headers;
} 

const HEADERS_TOKEN_FILE = function() {
    const headers = {
        'Content-Type': 'multipart/form-data'
    };
    const token = localStorage.getItem('user_token');
    if (token) {
        headers['Authorization'] = 'Token ' + token;
    }
    return headers;
}
const HEADERS_TOKEN_JSON = function(){
    const headers = {
        'Accept': 'application/json',
    };
    const token = localStorage.getItem('user_token');
    if (token) {
        headers['Authorization'] = 'Token ' + token;
    }
    return headers;
}

const HEADERS_TOKEN_JSON_FILE = function(){
    const headers = {
        'Accept': 'application/json',
        'Content-Type': 'multipart/form-data',
    };
    const token = localStorage.getItem('user_token');
    if (token) {
        headers['Authorization'] = 'Token ' + token;
    }
    return headers;
}

const HEADERS_JSON = {
    'Accept': 'application/json',
}

function HEADERS_JSON_CLIENT() {
    return {
        'Authorization': 'Bearer ' + localStorage.getItem('client_token'),
        'Accept': 'application/json',
    };
}

const API_CONTENT = {
    list: `${BASE_URL}/api/content/`,
}

const API_COURSES = {
    list: `${BASE_URL}/api/courses/`,
    admin: `${BASE_URL}/api/admin/courses/`,
} 

const API_USERS = {
    list: `${BASE_URL}/api/admin/users-all/`,
} 

const API_PROFILE = {
    list: `${BASE_URL}/api/client/full-profile/`,
} 

const API_EXPERTS = {
    list: `${BASE_URL}/api/admin/experts/`,
    users: `${BASE_URL}/api/admin/users/experts/`,
    courses: `${BASE_URL}/api/admin/courses/`,
    public: `${BASE_URL}/api/client/expert-public/`,
}

const API_EXPERT_RATING = {
    list: `${BASE_URL}/api/expert/ratings/`,
}

const API_TRAININGS = {
    list: `${BASE_URL}/api/admin/v2/trainings/`,
}

const API_COURSE_PREPARATION = {
    list: `${BASE_URL}/api/admin/v2/preparation/course/`,
}

const API_PILOT_SERVICES = {
    list: `${BASE_URL}/api/admin/pilot-services/`,
    create: `${BASE_URL}/api/admin/pilot-services/`,
    base: `${BASE_URL}/api/admin/pilot-services/`,
}

const API_PILOT_SERVICES_PUBLIC = {
    list: `${BASE_URL}/api/pilot-services-public/`,
}

const API_PILOT_SERVICES_CREATE = {
    create: `${BASE_URL}/api/pilot-services-create/`,
}

const API_PILOT_ANNOUNCEMENTS = {
    list: `${BASE_URL}/api/pilot-announcements/`,
    create: `${BASE_URL}/api/pilot-announcements/`,
    base: `${BASE_URL}/api/pilot-announcements/`,
    moduleComments: `${BASE_URL}/api/module-comments/`,
}

const API_PILOT_ANNOUNCEMENTS_PUBLIC = {
    list: `${BASE_URL}/api/pilot-announcements-public/`,
    create: `${BASE_URL}/api/pilot-announcements-public/`,
    base: `${BASE_URL}/api/pilot-announcements-public/`,
}

const API_ANNOUNCEMENT_RESPONSES = {
    list: `${BASE_URL}/api/announcement-responses/`,
    create: `${BASE_URL}/api/announcement-responses/`,
    base: `${BASE_URL}/api/announcement-responses/`,
}

const API_RESPONSE_MESSAGES = {
    list: `${BASE_URL}/api/response-messages/`,
    create: `${BASE_URL}/api/response-messages/`,
    base: `${BASE_URL}/api/response-messages/`,
}

const API_MODERATOR_RESPONSES = {
    list: `${BASE_URL}/api/moderator/announcement-responses/`,
    base: `${BASE_URL}/api/moderator/announcement-responses/`,
}

const API_CONTENT_SUGGEST = {
    list: `${BASE_URL}/api/content-suggest/`,
    create: `${BASE_URL}/api/content-suggest/`,
    base: `${BASE_URL}/api/content-suggest/`,
}

const API_COURSE_SUGGEST = {
    list: `${BASE_URL}/api/preparation-course-suggest/`,
    create: `${BASE_URL}/api/preparation-course-suggest/`,
    base: `${BASE_URL}/api/preparation-course-suggest/`,
}

const API_COMMENTS = {
    list: `${BASE_URL}/api/module-comments/`,
    create: `${BASE_URL}/api/module-comments/`,
    base: `${BASE_URL}/api/module-comments/`,
}

const API_PASSWORD_RECOVERY = {
    list: `${BASE_URL}/api/password-recovery/`,
    create: `${BASE_URL}/api/password-recovery/`,
    base: `${BASE_URL}/api/password-recovery/`,
}

const API_LOGIN_ATTEMPTS = {
    list: `${BASE_URL}/api/admin/login-attempts/`,
}

const API_USER_FEEDBACK = {
    create: `${BASE_URL}/api/user-feedback/`,
    list: `${BASE_URL}/api/admin/user-feedback/`,
    base: `${BASE_URL}/api/admin/user-feedback/`,
}

export {
    BASE_URL, DEFAULT_PER_PAGE, API_TSOR,
    API_TRAININGS, API_COURSE_PREPARATION,
    API_AUTH, API_CONTENT,
    API_NEWS, API_CATEGORIES,
    API_EXPERTS, API_COURSES,
    API_CATEGORIES_CLIENT,
    API_USERS, API_PROFILE,
    API_EXPERT_RATING,
    HEADERS, HEADERS_TOKEN,
    HEADERS_TOKEN_FILE, HEADERS_TOKEN_JSON,
    HEADERS_JSON, HEADERS_JSON_CLIENT,
    HEADERS_TOKEN_JSON_FILE,
    API_USER, API_BASE,
    API_CLIENT, API_PILOT_SERVICES, API_PILOT_SERVICES_PUBLIC, API_PILOT_SERVICES_CREATE,
    API_PILOT_ANNOUNCEMENTS, API_PILOT_ANNOUNCEMENTS_PUBLIC,
    API_ANNOUNCEMENT_RESPONSES, API_RESPONSE_MESSAGES, API_MODERATOR_RESPONSES, API_CONTENT_SUGGEST,
    API_COMMENTS, API_COURSE_SUGGEST, API_PASSWORD_RECOVERY,
    API_LOGIN_ATTEMPTS, API_USER_FEEDBACK,
}
